import {
  Box,
  CircularProgress,
  Grid,
  Typography,
  useTheme,
} from "@mui/material";

import FancyCard from "components/FancyCard";
import ItemCard from "./Component/ItemCard";
import React from "react";
import { CheckSmall, CloseSmall } from "assets/Icon";

function BankAccountsCard({ bankAccountList, onClick }) {
  const theme = useTheme();

  return (
    <>
      {bankAccountList?.map((bankAccount) => (
        <Grid item xs={12}>
          <FancyCard
            color={theme.palette.background.blue}
            spacing={2}
            onClick={() => onClick(bankAccount)}
          >
            <Box display="flex" justifyContent=" space-between">
              <Box>
                <Typography variant="subtitle1" color="common.white">
                  {bankAccount?.date}
                </Typography>
                <Typography variant="subtitle1" color="common.white">
                  {bankAccount?.time}
                </Typography>
              </Box>
              <Typography variant="h6" color="common.white" fontWeight={600}>
                بانک {bankAccount?.bank}
              </Typography>
            </Box>
            <Box>
              <ItemCard
                itemBankAccount={bankAccount?.accountNumber}
                title={"شماره حساب"}
              />

              <ItemCard
                itemBankAccount={bankAccount?.cardNumber}
                title={"شماره کارت"}
              />

              <ItemCard
                itemBankAccount={bankAccount?.shabaNumber}
                title={" شماره شبا"}
              />

              <ItemCard
                itemBankAccount={bankAccount?.accountOwnerName}
                title={"  نام حساب"}
              />

              <Box display="flex" justifyContent="space-between">
                <Typography variant="h6" color="common.white">
                  {bankAccount?.stateId === 1 ? (
                    <Box>
                      <CircularProgress color="success" size={15} /> در انتظار
                      تایید
                    </Box>
                  ) : bankAccount.stateId === 2 ? (
                    <Box>
                      <CheckSmall color={theme.palette.modules.checked} /> تایید
                      شده
                    </Box>
                  ) : (
                    <Box>
                      <CloseSmall color={theme.palette.error.main} /> تایید نشده
                    </Box>
                  )}
                </Typography>
                <Typography variant="h6" color="common.white">
                  وضعیت
                </Typography>
              </Box>
            </Box>
          </FancyCard>
        </Grid>
      ))}
    </>
  );
}
export default BankAccountsCard;
